import React from 'react';
import './Page.css';
import { useTranslation } from 'react-i18next';

function FAQ({ onBack }) {
  const { t } = useTranslation();

  return (
    <div className="page-container">
      <h1>{t('faq_title')}</h1>

      <h2>{t('faq_q1')}</h2>
      <p>{t('faq_a1')}</p>

      <h2>{t('faq_q2')}</h2>
      <p>{t('faq_a2')}</p>

      <h2>{t('faq_q3')}</h2>
      <p>{t('faq_a3')}</p>

      <h2>{t('faq_q4')}</h2>
      <p>{t('faq_a4')}</p>

      <h2>{t('faq_q5')}</h2>
      <p>{t('faq_a5')}</p>

      <button className="back-button" onClick={onBack}>{t('back_to_home')}</button>
    </div>
  );
}

export default FAQ;

